export default "__VITE_ASSET__DxdkJe7A__"